import React from 'react';
import PropTypes from 'prop-types';

const HELP_EMAIL = 'invest_privatemarkets_platforms-l@amfam.com';

export default function HelpModal({ open, onClose }) {
  return (
    <>
      <div className={`overlay-black modal ${open && 'modal-open'}`}>
        <div className="border-dark-gray content pad-30">
          <p>
            For questions or issues with this site,
            please contact&nbsp;
            <a href={`mailto:${HELP_EMAIL}`}>
              {HELP_EMAIL}
            </a>
            .
          </p>
          <br />
          <p>
            To contact someone directly on the commercial mortgages closing team:
          </p>
          <ul className="margin-left-30">
            <li>Margaret Opper 608-245-8655</li>
            <li>Joan Dickrell 608-245-8640</li>
            <li>Barbara Hockett 608-245-8642</li>
          </ul>

          <br />
          <div className="text-center">
            <button className="text-center" type="button" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

HelpModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
